import React, { Component, Fragment } from 'react'
import DatePicker from '../../DatePicker'
import PropTypes from 'prop-types'
import moment from 'moment'

class PeriodScheduleRecharge extends Component {
  constructor (props) {
    super(props)
    this.state = { innitialDate: null, possibleEndDates: [] }
  }

  generatePossibleEndDates (innitialDate, quantityMonths) {
    var possibleEndDates = []
    if (!innitialDate) return possibleEndDates
    for (var i = 0; i < quantityMonths; i++) {
      possibleEndDates.push(
        moment(innitialDate)
          .add(i, 'month')
          .toDate()
      )
    }
    this.setState({ innitialDate: innitialDate, possibleEndDates })
  }

  render () {
    if (this.state.innitialDate !== this.props.innitialDate) {
      this.generatePossibleEndDates(
        this.props.innitialDate,
        this.props.maxQuantityMonths
      )
    }
    return (
      <Fragment>
        <div className='row mx-0'>
          <div className='col-12 border-dotted-top color-ui-3 mt-2' />
          <div className='col-md-12 col-lg-12 txt-title-3 txt-body-sm txt-font-body txt-left mt-2 color-ui-2 px-0 mb-1'>
            Aqui você escolhe a data inicial de resgate e este dia será repetido
            todo mês até a data termino.
          </div>
          <div className='col-6 pl-0'>
            <div className='row'>
              <DatePicker
                name='datainicio'
                onChange={this.props.onChangeInnitialDate}
                selected={this.props.innitialDate}
                minDate={moment(new Date())
                  .add(1, 'days')
                  .toDate()}
                labelDescription='Data de início'
              />
            </div>
          </div>
          <div className='col-6 pr-0'>
            <div className='row'>
              <DatePicker
                name='datatermino'
                labelDescription='Data de término'
                onChange={this.props.onChangeEndDate}
                selected={this.props.endDate}
                disabled={!this.props.innitialDate}
                includeDates={this.state.possibleEndDates}
                highlightDates={this.state.possibleEndDates}
                locale='pt'
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12 color-ui-3 px-0'>
            <div className='row' />
          </div>
        </div>
      </Fragment>
    )
  }
}

PeriodScheduleRecharge.propTypes = {
  onChangeInnitialDate: PropTypes.func,
  innitialDate: PropTypes.objectOf(typeof date),
  onChangeEndDate: PropTypes.func,
  endDate: PropTypes.objectOf(typeof date),
  maxQuantityMonths: PropTypes.number
}

export default PeriodScheduleRecharge



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/ScheduleRecharge/PeriodScheduleRecharge.js